import { getSubCoursesByCourseId } from "../../mp-database"

export const getSubcourses = courseId => {
  return getSubCoursesByCourseId(courseId).then(querySnapshot => {
    let subcourses = []
    querySnapshot.forEach(doc => {
      let data = doc.data
      if (!data.deleted) {
        subcourses.push(data)
      }
    })
    return subcourses
  })
}
